// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "saude-diaria.firebaseapp.com",
  "projectId": "saude-diaria",
  "storageBucket": "saude-diaria.appspot.com",
  "messagingSenderId": "1059051645950",
  "appId": "1:1059051645950:web:1f51852a754e667bd72eaf",
  "measurementId": "G-20VPVZCY0R",
  "apiKey": "AIzaSyAFimqajKJQPod5VFKhmZdwUiTXSylKpLI"
};
